module.exports = __webpack_public_path__ + "static/theory11-6d343b094e39133e874949a2a556172b.svg";